/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateSisenseUserInput = {
    email?: string | null | undefined;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    type?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateSisenseUserMutationVariables = {
    input: CreateSisenseUserInput;
};
export type CreateSisenseUserMutationResponse = {
    readonly createSisenseUser: {
        readonly viewer: {
            readonly id: string;
            readonly sisenseUserId: string | null;
        } | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type CreateSisenseUserMutation = {
    readonly response: CreateSisenseUserMutationResponse;
    readonly variables: CreateSisenseUserMutationVariables;
};



/*
mutation CreateSisenseUserMutation(
  $input: CreateSisenseUserInput!
) {
  createSisenseUser(input: $input) {
    viewer {
      id
      sisenseUserId
    }
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSisenseUserInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSisenseUserPayload",
    "kind": "LinkedField",
    "name": "createSisenseUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sisenseUserId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSisenseUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSisenseUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateSisenseUserMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSisenseUserMutation(\n  $input: CreateSisenseUserInput!\n) {\n  createSisenseUser(input: $input) {\n    viewer {\n      id\n      sisenseUserId\n    }\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b33d571581ad1769add7e0a364aa06ed';
export default node;
